import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import Pagination from "react-js-pagination";
import {
  fetchCourses,
  searchCourses,
  openCourseModal,
  clearUnpublished,
} from "CourseAction";
import { itemCount } from "Constants";
import NoContent, { NO_COURSE } from "NoContentAdded";
import CourseItem from "./course-item-list";
import AddCourse from "./add-course";
import LocaleStrings from "Languages";

class Course extends Component {
  constructor(props) {
    super(props);
    this.state = { pageNumber: 1, search: "" };
  }

  componentDidMount() {
    this.props.fetchCourses(this.props.session);
    this.props.clearUnpublished();
  }

  openModal = () => {
    this.props.openCourseModal({ showModal: true, action: "add" });
  };

  _handleSearch = (e) => {
    let { session } = this.props;
    var search = e.target.value;
    var pageNumber = 1;

    if (search == "") {
      this.props.fetchCourses(session, pageNumber, (response) => {});
    } else {
      this.props.searchCourses(session, search, pageNumber, (response) => {});
    }
    this.setState({ search, pageNumber });
  };

  paginationCallback = (pageNumber) => {
    let { session } = this.props;
    let { search } = this.state;

    if (search == "") {
      this.props.fetchCourses(session, pageNumber, (response) => {});
    } else {
      this.props.searchCourses(session, search, pageNumber, (response) => {});
    }

    this.setState({ ...this.state, pageNumber });
  };

  additionCallback = () => {
    // after update call this method with page no. as param, it will display as your current search or sort rocord
    this.paginationCallback(this.state.pageNumber);
  };

  renderList = () => {
    let { courseList } = this.props;
    let { pageNumber } = this.state;
    let pageDataLength =
      courseList && courseList.data ? courseList.data.length : 0;

    return _.map(courseList.resource, (item, index) => {
      return (
        <CourseItem
          key={`key_${index}`}
          listItem={item}
          pageDataLength={pageDataLength}
          currentPage={pageNumber}
          pagination={this.paginationCallback}
        />
      );
    });
  };

  render() {
    let { courseList, showModal, deviceSize } = this.props;
    let { search, pageNumber } = this.state;

    return (
      <div>
        <div className="content-header-bar">
          <div className="pull-right h-100 vertical-align-center">
            <ul className="header-buttons">
              <li>
                <input
                  className="form-control mapsearch"
                  placeholder={LocaleStrings.button_search}
                  type="text"
                  value={search}
                  onChange={this._handleSearch}
                />
              </li>
              <li>
                <button
                  type="button"
                  className="btn btn-custom-blue"
                  onClick={this.openModal}
                >
                  <i className="fa fa-plus i-custom-m"></i>
                  {LocaleStrings.button_add_new}
                  {/* <img  style={{paddingRight:8, paddingBottom:3 }} src='../../style/images/header-icons/plus.png'></img>{LocaleStrings.button_add_new} */}
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div
          className="panel-body scrollable-content"
          // style={{ height: deviceSize.height - 138 }}
        >
          {courseList && courseList.count > 0 ? (
            <div className="">
              <table className="table">
                <thead>
                  <tr>
                    <th># {LocaleStrings.course_table_list_course_name}</th>
                    <th>{LocaleStrings.course_table_list_total_chapters}</th>
                    <th>{LocaleStrings.course_table_list_total_lessons}</th>
                    <th className="w-300px">
                      {LocaleStrings.course_table_list_actions}
                    </th>
                  </tr>
                </thead>
                <tbody className="tbody-background">{this.renderList()}</tbody>
              </table>

              {courseList.count > itemCount ? (
                <Pagination
                  activePage={pageNumber}
                  itemsCountPerPage={itemCount}
                  totalItemsCount={courseList.count}
                  pageRangeDisplayed={10}
                  onChange={this.paginationCallback}
                  style={{ float: "right" }}
                />
              ) : (
                ""
              )}
            </div>
          ) : (
            <NoContent contentType={NO_COURSE} />
          )}
        </div>

        {showModal && showModal.showModal ? (
          <AddCourse finishOperationsCallback={this.additionCallback} />
        ) : (
          ""
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    courseList: state.courseList,
    showModal: state.courseModal,
    deviceSize: state.deviceSize,
  };
}

export default connect(mapStateToProps, {
  fetchCourses,
  searchCourses,
  openCourseModal,
  clearUnpublished,
})(Course);
